import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  href?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#00A862]';
  const variantStyles = {
    primary: 'bg-[#00A862] text-white hover:bg-[#008F54] border border-transparent shadow-md',
    outline: 'bg-transparent text-[#00A862] hover:bg-[#F0F9F4] border-2 border-[#00A862]',
    ghost: 'bg-transparent text-[#00A862] hover:bg-[#F0F9F4] border border-transparent'
  };
  const sizeStyles = {
    sm: 'text-sm px-3 py-2',
    md: 'text-sm px-5 py-2.5',
    lg: 'text-base px-8 py-3.5'
  };
  const classes = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  if (href) {
    return <a href={href} className={classes} data-id="element-544">
        {children}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-545">
      {children}
    </button>;
}